import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { message,Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker ,Select ,Modal } from 'antd';


import attached from '../../assets/images/icon/paperclip.png';
import music from '../../assets/images/icon/music.png';
import pdf_ from '../../assets/images/icon/pdf_.png';
import image from '../../assets/images/icon/image.png';
import person from '../../assets/images/icon/person.png';
import correct from '../../assets/images/icon/correct.png';
import wrong from '../../assets/images/icon/wrong.png';
import edit from '../../assets/images/icon/edit.png';

const { TextArea } = Input;
const { Panel } = Collapse;

const buttonWidth = 70;


function callback(key) {
  console.log(key);
}



function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}

class Index extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			size: 'default',
			quant: 'default',
			like: 'default',
			comment: 'default',
			notification: 'default',
			value: '',
			child: false,
			pickup_point: '',
			pickup_time: '',
			drop_time: '',
			children_id: [],
			school_list: [],
			selected_student: [],
			selected_student_data: [],
			selected_program: [],
			program_list: [],
  		    program_id: [],
		}
		this.onChangestart = this.onChangestart.bind(this);	
		this.onChangeend = this.onChangeend.bind(this);	
		this.handleClick = this.handleClick.bind(this);
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		this.setState({ user_id : storedArray['data'][0]['user_id'],school_id : storedArray['data'][0]['school_id']});
		this.checkData();
		}
	}
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			 this.setState({ 
			 user_id : storedArray['data'][0]['user_id'], 
			 staff_id : this.props.match.params.id, 
			 });
			var user_id = storedArray['data'][0]['user_id'];
			
			var app = {user_id : user_id,}
			getData('erp/student_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							school_list: result['data'],
						});
					}else{
						this.setState({
							school_list: [],
						});
					}
				}
			});
			
						
	}
  }
	
	handleSizeChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };
  
  
  handleSubmit=(e)=>{
    e.preventDefault();
	if(localStorage.getItem('schoolData')){
    this.setState({ loading: true });
    var id = this.state.type
      getData('erp/pickup_point_add',this.state).then((result) => {
      if(result.status==400){
            message.config({ top: 150});
			message.error('Please Insert All Field',2);
			this.setState({ loading: false });
          }
          if(result.status==200){
            message.config({ top: 150});
            message.success('Pickup added',2);
              this.setState({ loading: false });
              this.setState({comment_text:''});
              window.location.href = '/transport-setup/pickup-points';
              //this.checkdata();

          }
      });
	  }else{
		message.error('Please Login',2);	
	  }

  }
  
   get_selected_student(){	 
			var app2 = {user_id : this.state.selected_student,}
			getData('erp/student_list_selected',app2).then((result) => {
				let responseJson2 = result;
				if(responseJson2.data){
					if(result['status'] == 200){
						this.setState({
							selected_student_data: result['data'],
						});
					}else{
						this.setState({
							selected_student_data: [],
						});
					}
				}
			});	
			
	}
  
  showModal = () => {
    this.setState({
      staff: true,
    });
  };
  
  showchildModal = () => {
    this.setState({
      child: true,
    });
  };

   handleOk = e => {
    this.get_selected_student();
    console.log(e);
    this.setState({
      child: false,
      staff: false,
    });
  };

  handleCancel = e => {
    console.log(e);
    this.setState({
     child: false,
      staff: false,
    });
  };
  
  handleClick(event) {
        const target = event.target;
        var value = target.value;
		console.log(value);
        if(target.checked){
            this.state.selected_student[value] = value;   
            this.state.children_id[value] = value;   
        }else{
            this.state.selected_student.splice(value, 1);
            this.state.children_id.splice(value, 1);
        }
       console.log(this.state.selected_student);
		//this.checkData();
    }
	
  onChangestart(time, timeString) {
	  this.setState({
     pickup_time: timeString,
    });
	}

	onChangeend(time, timeString) {
	  this.setState({
     drop_time: timeString,
    });
	}	
	
	render()

	{
	
	const { size } = this.state;
	const content = (
					  <div>
						<p className="center upload-img"><Tooltip placement="right" title="Audio"><img src={music} class="" alt="image" /></Tooltip></p>
						<p className="center upload-img"><Tooltip placement="right" title="Pdf"><img src={pdf_} class="" alt="image" /></Tooltip></p>
						<p className="center upload-img"><Tooltip placement="right" title="Image"><img src={image} class="" alt="image" /></Tooltip></p>
						
					  </div>
					);
	const radioStyle = {
		  display: 'block',
		  height: '30px',
		  lineHeight: '30px',
		};				
					
		return (
			<div class="mobile_view">
			
			<div id="main" class="bg-off">
         <div class="row">
		 
		 <div class="col s12 m12 ex-padd">
            <div id="breadcrumbs-wrapper" class="bg-off">
               <div class="">
                  <div class="row no-margin">
				  <div class="col s12 m12 header-title mt-20 mh-40 iq-card">
                     <div class="col s12 m6 l6 pt-10">
                        <h5 class="breadcrumbs-title"><span>Add Pickup Points</span></h5>
                     </div>
                     <div class="col s12 m6 l6 right-align-md pt-10">
                         <ol class="breadcrumbs mb-0">
                           <li class="breadcrumb-item"><a href="/">Home</a>
                           </li>
						   <li class="breadcrumb-item"><a href="/transport-setup/index">Transport Setup</a>
                           </li>
                           <li class="breadcrumb-item active"><a href="/transport-setup/pickup-points">Pickup Points</a>
                           </li>
                           <li class="breadcrumb-item active">Add Pickup Points
                           </li>
                        </ol>
                     </div>
                     </div>
                  </div>
               </div>
            </div>
            </div> 
		 
		            
        
		 <div class="col s12 m12 ex-padd">    
            <div class="container view-Profile viewprograms">
			   <div class="col s12 m12 mb-20 mt-10 card-content iq-card">
                  <section class="invoice-list-wrapper section food pickup ">
					<div class="children mb-20 iq-card2 bg-color-1">
                     <Collapse defaultActiveKey={['1']} onChange={callback}>
						<Panel header="Malad" classname="as" key="1">
						<div class="bb d-flow">
						<div class="col m12 s12 no-padd">
						<div class="col m12 s12">
							<label>Pickup Point</label>
							<input type="text"  name="pickup_point" onChange={this.handleSizeChange}  />
						</div>
						<div class="col m6 s12">
									<label class="d-block">Pickup Time</label>
									<TimePicker use12Hours format="h:mm a" onChange={this.onChangestart} />
								</div>
								<div class="col m6 s12">
									<label class="d-block">Drop Time</label>
									<TimePicker use12Hours format="h:mm a" onChange={this.onChangeend} />
								</div>
						</div>
						
						 
						</div>  
						
						</Panel>
					  </Collapse>
					</div> 
					<div class="children bg-blue communication mb-20 pb-20 iq-card2 bg-color-6">
                     <Collapse defaultActiveKey={['1']} onChange={callback}>
						<Panel header="Children"  key="1">
							
							<div class="col m12 center pb-20">
								<Button className="snd-btn" onClick={this.showchildModal}>Select</Button>
							</div>
							 <div class="children bg-blue attendance">
								  <Checkbox.Group  name="children_id[]" >
								
									{this.state.selected_student_data.map((list) => (
									   <Checkbox value={list.id} id={list.id} defaultChecked={true} readonly><label class="w-m" for={list.id} >
									   <div class="center"><img src={person} class="atd-img" /> {list.first_name} {list.last_name}</div>
									   </label>
									   </Checkbox>
									))}   
									   
									   
									</Checkbox.Group>
							</div>			  
						  
						  <Modal
								  title="Select Child"
								  visible={this.state.child}
								  onOk={this.handleOk}
								  onCancel={this.handleCancel}
								  
								>
								  <div class="children bg-blue attendance">
									  <Checkbox.Group  name="item_name[]" >
								
									{this.state.school_list.map((list) => (
									   <Checkbox value={list.id} id={list.id} defaultChecked={false}  onChange={this.handleClick}><label for={list.id} >
									   <div class="center"><img src={person} class="atd-img" /> {list.first_name} {list.last_name}</div>
									   </label>
									   </Checkbox>
									))}   
									   
									   
									</Checkbox.Group>
								</div>
								</Modal>
						</Panel>
					  </Collapse>
					</div>				
					
					
					<div class="col m12 s12 meal mt-20 mb-20 pt-20 bt center">
						 <Button className="cancel-btn" >Back</Button>
						 <Button className="snd-btn" onClick={this.handleSubmit} loading={this.state.loading}>Save</Button>
					</div>
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
            </div>
         </div>
      </div>
     
			</div>
		) 
	} 
}
export default Index;
